import { render, staticRenderFns } from "./goodsInfo.vue?vue&type=template&id=2db785fe&scoped=true&"
import script from "./goodsInfo.vue?vue&type=script&lang=ts&"
export * from "./goodsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./goodsInfo.vue?vue&type=style&index=0&id=2db785fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db785fe",
  null
  
)

export default component.exports